import clsx from 'clsx';
import { ReactComponent as DocumentOnTable } from 'assets/images/document-on-table.svg';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';
import { useNavigate } from 'react-router-dom';
import { ScanPageWizardStepScan } from 'routes/paths';
import styles from './index.module.scss';
import StepDescription from '../StepDescription';
import { DocumentTypeEnum } from 'common/document/enums/document-type.enum';
import { useMemo } from 'react';

export interface FlatSurfaceStepProps {
  className?: string;
  documentRequestId: string;
  documentId: string;
  documentType: string;
  documentTypeEnum?: DocumentTypeEnum;
}

function FlatSurfaceStep(props: FlatSurfaceStepProps) {
  const navigate = useNavigate();

  const title = useMemo(() => {
    if (props.documentTypeEnum === DocumentTypeEnum.PHOTO_ID) {
      return 'The license you uploaded does not have your photo on it. Please upload a valid photo ID.';
    }
    if (props.documentTypeEnum === DocumentTypeEnum.RETURN_TO_WORK) {
      return 'Place Return To Work document on a Flat Surface.';
    }
    if (props.documentTypeEnum === DocumentTypeEnum.DRIVER_LICENSE) {
      return 'Place Driver License document on a Flat Surface.';
    }
    if (props.documentTypeEnum === DocumentTypeEnum.DOT_MEDICAL) {
      return 'Place DOT Med Cert document on a Flat Surface.';
    }
    if (props.documentTypeEnum === DocumentTypeEnum.MEDICAL_DISCONTINUANCE) {
      return 'Place Medical Discontinuance Form document on a Flat Surface.';
    }
    return 'Place Document on a Flat Surface.';
  }, [props.documentTypeEnum]);

  return (
    <div className={clsx(styles.root, props.className)}>
      <StepDescription title={title} />

      <DocumentOnTable className={styles.table} />

      <div className={styles.actions}>
        <ButtonWithArrowIcon
          variant="contained"
          color="primary"
          onClick={() => {
            navigate(
              ScanPageWizardStepScan.replace(
                ':documentRequestId',
                props.documentRequestId
              )
                .replace(':documentType', props.documentType)
                .replace(':documentTypeEnum', props.documentTypeEnum || '')
                .replace(':documentId', props.documentId)
            );
          }}
        >
          Scan Document
        </ButtonWithArrowIcon>
      </div>
    </div>
  );
}

export default FlatSurfaceStep;
